import React from 'react';

import { useAppDispatch, useAppSelector } from 'segments/hooks';

import { changeCourtsActiveModal, selectCourtsActiveModal, useGetCourtsListQuery } from 'features/courts';

import CreateCourtModal from './components/CreateCourtModal';
import EditCourtModal from './components/EditCourtModal';

type Props = {
  selectedCourtId?: number;
};

export const CourtsModals = ({ selectedCourtId }: Props) => {
  const { data: courtsList = [], isLoading: isCourtsLoading } = useGetCourtsListQuery();
  const activeModal = useAppSelector(selectCourtsActiveModal);
  const dispatch = useAppDispatch();
  const closeModal = () => dispatch(changeCourtsActiveModal(null));

  if (isCourtsLoading) {
    return;
  }

  return (
    <>
      <EditCourtModal
        key={`editCourt${selectedCourtId}`}
        isModalOpen={activeModal === 'edit-court-modal' && selectedCourtId !== undefined}
        handleCancel={closeModal}
        data={courtsList.find((court) => court.id === selectedCourtId)}
      />
      <CreateCourtModal
        key={'createCourt'}
        isModalOpen={activeModal === 'create-court-modal'}
        handleCancel={closeModal}
      />
    </>
  );
};
